import React, { useState, useEffect } from 'react';
import './styles.scss'
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';

function BannerHeroPagination({swiperState, length, isLoading}) {
    const [indexActive,setIndexActive] = React.useState(0);
    const [ sliderMove, setSliderMove ] = React.useState(false);

    const handlerNext = ()=>{
        swiperState.slideNext();
    }
    
    const handlerPrev = ()=>{
        swiperState.slidePrev();
    }

    const indexChange = (index)=>{
        swiperState.slideTo(index)
    }

    React.useEffect(()=>{
        if(typeof swiperState?.on == 'function' && !swiperState.destroyed){
            swiperState?.on('slideChange', function (swiper) {
                setIndexActive(swiper.realIndex);
            });
            swiperState?.on('sliderMove', ()=>setSliderMove(true));
            swiperState?.on('touchEnd', ()=>setSliderMove(false));
        }
        return () => {
            swiperState?.off('slideChange');
            swiperState?.off('sliderMove');
            swiperState?.off('touchEnd');
        }
    },[swiperState,isLoading]);
    
    return (
    <div className="bannerHeroPagination" style={{opacity: sliderMove ? 0 : 1, transition: 'opacity 300ms ease-in-out'}}>
        <Button className="bannerHeroPagination__button bannerHeroPagination__Prev" onClick={handlerPrev}><i className='bi bi-chevron-left'/></Button>
        <ul className="bannerHeroPagination__pagination">
            {[...new Array(length)].map((e,index)=>
                <li className="bannerHeroPagination__item" key={'bannerHeroPagination__item-'+index}>
                    <a onClick={()=>indexChange(index+1)} className={"bannerHeroPagination__link"+(indexActive===index?" is_active":'')}/>
                </li>
            )}
        </ul>
        <Button className="bannerHeroPagination__button bannerHeroPagination__Next" onClick={handlerNext}><i className='bi bi-chevron-right'/></Button>
    </div>
    );
};

export default BannerHeroPagination;
